module.exports = __webpack_public_path__ + "img/camera.91aa1150.svg";